import { ZyNodeViewWrapper } from '@/components/common/node-view-wrapper';
import { type ReactNodeViewProps, NodeViewContent } from '@tiptap/react';

const MatchingPairDefinitionNodeView: React.FC<ReactNodeViewProps> = ({ decorations }) => {
    return (
        <ZyNodeViewWrapper
            decorations={decorations}
            className="w-full"
        >
            <label className="my-1 block text-xs font-medium text-gray-600 dark:text-gray-400">Definition</label>
            <NodeViewContent className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus-within:border-blue-500 focus-within:ring-2 focus-within:ring-blue-500 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-200" />
        </ZyNodeViewWrapper>
    );
};

export default MatchingPairDefinitionNodeView;
